<template>
  <div
    class="wrapper"
    style="
      padding-top: 0px;
      margin: 0px;
      width: 100%;
      height: 100%;
      background-color: #f6f6f6;
      max-width: 100%;
    "
  >
    <header class="show_header">
      <div>
        <button class="btn-sidebar" @click="$router.go(-1)">
          <img src="@/assets/img/arrow_back.svg" />
        </button>
      </div>

      <div class="header_title">
        <h3 class="upper title">ShowTimes</h3>
      </div>
      <div>
        <img
          src="@/assets/img/camera.svg"
          width="100%"
          class=""
          @click="scannerSection()"
        />
      </div>
      <div class="">
        <button class="btn-logout" @click="onLogout()"> Logout </button>
      </div>
    </header>
    <!---Time & Date---->
    <section>
      <h3 class="upper date">{{ ShowDate }}</h3>
    </section>

    <section class="top-controls">
      <div class="view-toggle-section">
        <button
          :class="['view-toggle-btn', { active: viewMode === 'show' }]"
          style="margin-right: 10px"
          @click="setViewMode('show')"
        >
          shows
        </button>
        <button
          :class="['view-toggle-btn', { active: viewMode === 'movie' }]"
          @click="setViewMode('movie')"
        >
          movies
        </button>
      </div>

      <div class="filter-container">
        <select
          v-model="selectedScreenFilter"
          @change="onScreenFilterChange"
          class="screen-filter-select"
        >
          <option value="">All Screens ({{ availableScreens.length }})</option>
          <option
            v-for="screen in availableScreens"
            :key="screen.screen_id"
            :value="screen.screen_id"
          >
            {{ screen.screen_name }} ({{ getScreenShowCount(screen.screen_id) }}
            shows)
          </option>
        </select>

        <button
          v-if="selectedScreenFilter"
          @click="clearScreenFilter"
          class="clear-filter-btn"
          title="Clear Filter"
        >
          ✕
        </button>
      </div>
    </section>

    <!-- show wise -->

    <div v-if="viewMode === 'show'">
      <section
        class="show_card"
        v-for="(showItem, showIndex) in filterShowList"
        :key="`show-${showIndex}`"
        :ref="`show-${showIndex}`"
        :data-show-index="showIndex"
      >
        <!-- Movie Info Header -->
        <div class="movie-header">
          <div class="movie-thumbnail-container">
            <img
              v-if="getMovieArtwork(showItem.schedule)"
              :src="getMovieArtwork(showItem.schedule)"
              :alt="showItem.schedule.original_movie_title"
              class="movie-thumbnail"
              @error="onImageError"
            />
            <div v-else class="movie-thumbnail-placeholder">
              <img :src="placeholder" class="movie-thumbnail" />
            </div>
          </div>
          <div class="movie-info">
            <h3 class="movie-title">
              {{ showItem.schedule.original_movie_title }}
              <span class="movie-year">
                ({{
                  moment(
                    showItem.schedule.mrrdr_release_date,
                    "YYYY-MM-DD"
                  ).format("YYYY")
                }})
              </span>
            </h3>
            <div class="movie-meta">
              <span class="rating-badge">{{ showItem.schedule.rating }}</span>
              <span class="divider">/</span>
              <span class="runtime-badge"
                >{{ showItem.schedule.runtime }} min</span
              >
              <span class="show-format">{{ showItem.show.mf_name }}</span>
              <span
                class="version-badge"
                v-if="
                  showItem.schedule.screens &&
                  showItem.schedule.screens.length > 0
                "
              >
                {{ showItem.schedule.screens[0].version_full_name }}
              </span>
            </div>
          </div>
        </div>

        <div class="show-details">
          <div class="show-main-info">
            <h2 class="screen_title" style="margin-right: 10px">
              <span
                class="status-dot"
                :class="getShowStatus(showItem.show)"
                :title="getShowStatusText(showItem.show)"
              ></span>
              {{ showItem.screen.screen_name }}
            </h2>

            <span class="show-timings">
              {{
                showItem.show.ss_start_show_time
                  ? moment(showItem.show.ss_start_show_time, "HH:mm").format(
                      "h:mm A"
                    )
                  : ""
              }}
              -
              {{
                showItem.show.ss_end_show_time
                  ? moment(showItem.show.ss_end_show_time, "HH:mm").format(
                      "h:mm A"
                    )
                  : ""
              }}
            </span>

            <div class="progress-bar-container">
              <div
                class="progress-bar"
                :style="{
                  '--progress': calculateOccupancyPercentage(showItem.show),
                }"
              >
                <span class="progress-text">
                  {{ showItem.show.booked_seats || 0 }}/{{
                    showItem.show.screen_total_seats
                  }}
                </span>
              </div>
            </div>

            <button
              @click="
                onViewSeatLayout(
                  showItem.schedule,
                  showItem.screen,
                  showItem.show
                )
              "
              class="seat-layout-btn"
              title="View Seat Layout"
            >
              <img
                class="movie-thumbnail"
                src="@/assets/img/seat_layout_icon.png"
              />
            </button>
          </div>

          <div class="show-additional-info">
            <!-- <div class="show-format">{{ showItem.show.mf_name }}</div> -->
            <div
              class="seat-types-row mt-1"
              v-if="
                showItem.show.seatTypes && showItem.show.seatTypes.length > 0
              "
            >
              <div class="seat-types-flex-container">
                <div
                  v-for="(seatType, seatIndex) in showItem.show.seatTypes"
                  :key="`seat-${seatIndex}`"
                  class="seat-type-item"
                >
                  <span class="seat-type-label">{{
                    seatType.seat_type_name
                  }}</span>
                  <span class="seat-type-dash">-</span>
                  <span class="seat-type-value">{{
                    seatType.booked_seats_of_type || 0
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!--Shedule 1--->

    <div v-else>
      <section
        class="schedule_main"
        v-for="(schedule, schIndex) in filteredScheduleList"
        :key="schIndex"
        :ref="`schedule-${schIndex}`"
        :data-schedule-index="schIndex"
      >
        <div class="d-flex align-items-center">
          <div class="movie-thumbnail-container">
            <img
              v-if="getMovieArtwork(schedule)"
              :src="getMovieArtwork(schedule)"
              :alt="schedule.original_movie_title"
              class="movie-thumbnail"
              @error="onImageError"
            />
            <div v-else class="movie-thumbnail-placeholder">
              <!-- <span>No Image</span> -->
              <!-- <img
              class="movie-thumbnail"
              src="@/assets/img/Placeholder_view_vector.svg"
            /> -->
              <img :src="placeholder" class="movie-thumbnail" />
            </div>
          </div>
          <div class="movie-details">
            <h3 class="title">
              {{ schedule.original_movie_title }}
              <span style="font-size: 12px; color: #818183">
                ({{
                  moment(schedule.mrrdr_release_date, "YYYY-MM-DD").format(
                    "YYYY"
                  )
                }})</span
              >
            </h3>
            <div
              class="d-flex align-items-center"
              style="margin-top: 5px; margin-left: 5px"
            >
              <div class="rating">{{ schedule.rating }}</div>
              <span style="margin: 0 10px">/</span>
              <div class="rating">{{ schedule.runtime }} min</div>
              <!-- <span>/</span> -->
              <!-- <div
              class="rating"
              v-if="schedule.screens && schedule.screens.length > 0"
            >
              {{ schedule.screens[0].version_full_name }}
            </div> -->
              <!-- <button
              class="language"
              v-if="schedule.screens && schedule.screens.length > 0"
            >
              {{ schedule.screens[0].version_full_name }}
            </button> -->
            </div>
          </div>
        </div>
        <section class="screening_section">
          <div class="shows-container">
            <div
              v-for="(showData, showIndex) in getAllShowsSortedByTime(schedule)"
              :key="`global-${showIndex}`"
              class="showtime-box"
            >
              <div class="showtime-row">
                <h2 class="screen_title">
                  <span
                    class="status-dot"
                    :class="getShowStatus(showData.show)"
                    :title="getShowStatusText(showData.show)"
                  ></span>
                  {{ showData.screen.screen_name }}
                </h2>

                <span class="show-timings">
                  {{
                    showData.show.ss_start_show_time
                      ? moment(
                          showData.show.ss_start_show_time,
                          "HH:mm"
                        ).format("h:mm A")
                      : ""
                  }}
                  -
                  {{
                    showData.show.ss_end_show_time
                      ? moment(showData.show.ss_end_show_time, "HH:mm").format(
                          "h:mm A"
                        )
                      : ""
                  }}
                </span>

                <div class="progress-bar-container">
                  <div
                    class="progress-bar"
                    :style="{
                      '--progress': calculateOccupancyPercentage(showData.show),
                    }"
                  >
                    <span class="progress-text">
                      {{ showData.show.booked_seats || 0 }}/{{
                        showData.show.screen_total_seats
                      }}
                    </span>
                  </div>
                </div>
                <button
                  @click="
                    onViewSeatLayout(schedule, showData.screen, showData.show)
                  "
                  class="seat-layout-btn"
                  title="View Seat Layout"
                >
                  <img
                    class="movie-thumbnail"
                    src="@/assets/img/seat_layout_icon.png"
                  />
                </button>
              </div>
              <div class="d-flex align-items-center seat-types-row mt-1">
                <div class="seat-type-item" style="margin-right: 10px">{{
                  showData.show.mf_name
                }}</div>
                <!-- <span>/</span> -->
                <div
                  class="seat-type-item"
                  v-if="schedule.screens && schedule.screens.length > 0"
                >
                  {{ schedule.screens[0].version_full_name }}
                </div>
              </div>
              <div
                class="seat-types-row mt-1"
                v-if="
                  showData.show.seatTypes && showData.show.seatTypes.length > 0
                "
              >
                <div class="seat-types-flex-container">
                  <div
                    v-for="(seatType, seatIndex) in showData.show.seatTypes"
                    :key="`seat-${seatIndex}`"
                    class="seat-type-item"
                  >
                    <span class="seat-type-label">{{
                      seatType.seat_type_name
                    }}</span>
                    <span class="seat-type-dash">-</span>
                    <span class="seat-type-value">{{
                      seatType.booked_seats_of_type || 0
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
    <ShowSeatLayoutPopup
      modalId="seatLayoutView"
      :md_id="selectedShowDetails.md_id"
      :screen_id="selectedShowDetails.screen_id"
      :ss_id="selectedShowDetails.ss_id"
      :cinema_id="selectedShowDetails.cinema_id"
      :showDetails="selectedShowDetails.showDetails"
    />
  </div>
</template>

<script>
  import BookingService from "@/services/BookingService";
  import moment from "moment";
  import ShowSeatLayoutPopup from "@/components/Partials/ShowSeatLayoutPopup.vue";
  import placeholder from "@/assets/img/Placeholder_view_vector.svg";
  export default {
    components: {
      ShowSeatLayoutPopup,
    },
    name: "hello",
    data() {
      return {
        bookingCode: "",
        scheduleList: [],
        cinema_id: null,
        ShowDate: moment().format("DD.MMM.YYYY"),
        availableScreens: [],
        selectedScreenFilter: "",
        viewMode: "show",
        autoScrollPerformed: false,
        selectedShowDetails: {
          md_id: null,
          screen_id: null,
          ss_id: null,
          cinema_id: null,
          showDetails: {
            screen_name: "",
            movie_name: "",
            ss_actual_start_date: "",
            ss_start_show_time: "",
          },
        },
        placeholder,
      };
    },
    computed: {
      // filter show wise

      filteredScheduleList() {
        let list = this.scheduleList;

        if (this.selectedScreenFilter) {
          list = list.filter((schedule) => {
            if (!schedule.screens || !Array.isArray(schedule.screens)) {
              return false;
            }
            return schedule.screens.some(
              (screen) =>
                screen.screen_id.toString() ===
                this.selectedScreenFilter.toString()
            );
          });
        }

        return list.sort((a, b) => {
          const earliestA = this.getEarliestShowTime(a);
          const earliestB = this.getEarliestShowTime(b);

          if (!earliestA) return 1;
          if (!earliestB) return -1;
          const showsA = this.getAllShowsSortedByTime(a);
          const showsB = this.getAllShowsSortedByTime(b);

          if (showsA.length === 0) return 1;
          if (showsB.length === 0) return -1;

          const dateTimeA = this.convertToSortableDateTime(showsA[0].show);
          const dateTimeB = this.convertToSortableDateTime(showsB[0].show);

          return dateTimeA - dateTimeB;
        });
      },
      filterShowList() {
        const allShows = [];

        this.scheduleList.forEach((schedule) => {
          if (schedule.screens && Array.isArray(schedule.screens)) {
            schedule.screens.forEach((screen) => {
              if (
                this.selectedScreenFilter &&
                screen.screen_id !== this.selectedScreenFilter.toString()
              ) {
                return;
              }

              if (screen.shows && Array.isArray(screen.shows)) {
                screen.shows.forEach((showArray) => {
                  if (showArray.shows && Array.isArray(showArray.shows)) {
                    showArray.shows.forEach((show) => {
                      allShows.push({
                        show: show,
                        screen: screen,
                        schedule: schedule,
                      });
                    });
                  }
                });
              }
            });
          }
        });

        return allShows.sort((a, b) => {
          const dateTimeA = this.convertToSortableDateTime(a.show);
          const dateTimeB = this.convertToSortableDateTime(b.show);

          return dateTimeA - dateTimeB;
        });
      },
    },
    beforeMount() {
      this.cinema_id = window.localStorage.getItem("USERCINEINFO");
      this.getAllShowTimes();

      this.timeInterval = setInterval(() => {
        this.currentTime = moment().format("HH:mm");
      }, 60000);
    },
    beforeDestroy() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
      }
    },
    methods: {
      moment,

      convertToSortableDateTime(show) {
        const startDate = show.ss_actual_start_date || show.ss_start_date;
        const startTime = show.ss_start_show_time;

        if (!startDate || !startTime) return 0;

        let dateStr = startDate;
        if (dateStr.includes(" ")) {
          dateStr = dateStr.split(" ")[0];
        }

        const [hours, minutes] = startTime.split(":").map(Number);

        const showDateTime = moment(
          `${dateStr} ${startTime}`,
          "YYYY-MM-DD HH:mm"
        );

        return showDateTime.valueOf();
      },
      convertToBusinessDayMinutes(timeString) {
        if (!timeString) return 0;

        const [hours, minutes] = timeString.split(":").map(Number);
        let totalMinutes = hours * 60 + minutes;
        if (hours < 6) {
          totalMinutes += 24 * 60;
        }

        return totalMinutes;
      },

      // new section code show wise

      setViewMode(mode) {
        // this.viewMode = mode;
        this.viewMode = mode;
        this.autoScrollPerformed = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoScrollToRunningShows();
          }, 100);
        });
      },

      // new code status
      getShowStatus(show) {
        if (!show.ss_start_show_time || !show.ss_end_show_time) {
          return "status-unknown";
        }

        const currentMoment = moment();

        const startDate = show.ss_actual_start_date || show.ss_start_date;
        const endDate = show.ss_actual_end_date || show.ss_end_date;

        if (!startDate) {
          return "status-unknown";
        }

        let startDateStr = startDate.includes(" ")
          ? startDate.split(" ")[0]
          : startDate;

        let endDateStr = endDate
          ? endDate.includes(" ")
            ? endDate.split(" ")[0]
            : endDate
          : startDateStr;

        const showStart = moment(`${startDateStr} ${show.ss_start_show_time}`, [
          "YYYY-MM-DD HH:mm",
          "YYYY-MM-DD hh:mm A",
        ]);

        let showEnd = moment(`${endDateStr} ${show.ss_end_show_time}`, [
          "YYYY-MM-DD HH:mm",
          "YYYY-MM-DD hh:mm A",
        ]);

        if (showEnd.isBefore(showStart)) {
          showEnd = moment(showStart).add(
            moment(show.ss_end_show_time, "HH:mm").diff(
              moment(show.ss_start_show_time, "HH:mm"),
              "minutes"
            ),
            "minutes"
          );
        }

        // console.log("Start:", showStart.format("YYYY-MM-DD HH:mm"));
        // console.log("End  :", showEnd.format("YYYY-MM-DD HH:mm"));
        // console.log("Now  :", currentMoment.format("YYYY-MM-DD HH:mm"));

        if (currentMoment.isBetween(showStart, showEnd, null, "[]")) {
          return "status-running";
        } else if (currentMoment.isBefore(showStart)) {
          return "status-upcoming";
        } else {
          return "status-past";
        }
      },
      getShowStatusText(show) {
        const status = this.getShowStatus(show);
        switch (status) {
          case "status-running":
            return "Currently Running";
          case "status-upcoming":
            return "Upcoming Show";
          case "status-past":
            return "Show Completed";
          default:
            return "Status Unknown";
        }
      },

      hasRunningShows(schedule) {
        const allShows = this.getAllShowsSortedByTime(schedule);
        return allShows.some(
          (showData) => this.getShowStatus(showData.show) === "status-running"
        );
      },

      autoScrollToRunningShows() {
        if (this.autoScrollPerformed) return;

        this.$nextTick(() => {
          if (this.viewMode === "show") {
            const firstRunningScheduleIndex = this.filterShowList.findIndex(
              (showItem) =>
                this.getShowStatus(showItem.show) === "status-running"
            );

            if (firstRunningScheduleIndex !== -1) {
              const targetElement = this.$el.querySelector(
                `[data-show-index="${firstRunningScheduleIndex}"]`
              );

              if (targetElement) {
                targetElement.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
                this.autoScrollPerformed = true;
              }
            }
          } else {
            const firstRunningScheduleIndex =
              this.filteredScheduleList.findIndex((schedule) =>
                this.hasRunningShows(schedule)
              );

            if (firstRunningScheduleIndex !== -1) {
              const targetElement = this.$el.querySelector(
                `[data-schedule-index="${firstRunningScheduleIndex}"]`
              );
              if (targetElement) {
                targetElement.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
                this.autoScrollPerformed = true;
              }
            }
          }
        });
      },
      extractAvailableScreens() {
        const screenMap = new Map();

        this.scheduleList.forEach((schedule) => {
          if (schedule.screens && Array.isArray(schedule.screens)) {
            schedule.screens.forEach((screen) => {
              if (screen.screen_id && screen.screen_name) {
                screenMap.set(screen.screen_id.toString(), {
                  screen_id: screen.screen_id,
                  screen_name: screen.screen_name,
                });
              }
            });
          }
        });

        this.availableScreens = Array.from(screenMap.values()).sort((a, b) =>
          a.screen_name.localeCompare(b.screen_name, undefined, {
            numeric: true,
          })
        );
      },
      getScreenShowCount(screenId) {
        let count = 0;
        this.scheduleList.forEach((schedule) => {
          if (schedule.screens && Array.isArray(schedule.screens)) {
            const screen = schedule.screens.find(
              (s) => s.screen_id.toString() === screenId.toString()
            );
            if (screen && screen.shows) {
              screen.shows.forEach((showArray) => {
                if (showArray.shows && Array.isArray(showArray.shows)) {
                  count += showArray.shows.length;
                }
              });
            }
          }
        });
        return count;
      },

      getSelectedScreenName() {
        const screen = this.availableScreens.find(
          (s) => s.screen_id.toString() === this.selectedScreenFilter.toString()
        );
        return screen ? screen.screen_name : "";
      },

      onScreenFilterChange() {
        console.log("Screen filter changed to:", this.selectedScreenFilter);
      },

      clearScreenFilter() {
        this.selectedScreenFilter = "";
      },
      getFilteredShowsSortedByTime(schedule) {
        const allShowsWithScreenInfo = [];

        if (schedule.screens && Array.isArray(schedule.screens)) {
          schedule.screens.forEach((screen) => {
            if (
              this.selectedScreenFilter &&
              screen.screen_id.toString() !==
                this.selectedScreenFilter.toString()
            ) {
              return;
            }

            if (screen.shows && Array.isArray(screen.shows)) {
              screen.shows.forEach((showArray) => {
                if (showArray.shows && Array.isArray(showArray.shows)) {
                  showArray.shows.forEach((show) => {
                    allShowsWithScreenInfo.push({
                      show: show,
                      screen: screen,
                    });
                  });
                }
              });
            }
          });
        }

        return allShowsWithScreenInfo.sort((a, b) => {
          const dateTimeA = this.convertToSortableDateTime(a.show);
          const dateTimeB = this.convertToSortableDateTime(b.show);

          return dateTimeA - dateTimeB;
        });
      },

      getAllShowsSortedByTime(schedule) {
        return this.getFilteredShowsSortedByTime(schedule);
      },
      getMovieArtwork(schedule) {
        if (schedule.movie_content && schedule.movie_content.length > 0) {
          const contentWithArtwork = schedule.movie_content.find(
            (content) => content.artwork && content.artwork.trim() !== ""
          );
          return contentWithArtwork ? contentWithArtwork.artwork : null;
        }
        return null;
      },
      onImageError(event) {
        if (event.target) {
          event.target.src = this.placeholder;
        }
      },

      onViewSeatLayout(schedule, screen, show) {
        this.selectedShowDetails = {
          md_id: Number(show.md_id || schedule.movie_id),
          screen_id: Number(screen.screen_id || show.screen_id),
          ss_id: Number(show.ss_id),
          cinema_id: Number(this.cinema_id || show.cinema_id),
          showDetails: {
            screen_name: screen.screen_name || show.screen_name,
            movie_name: schedule.original_movie_title || show.movie_title,
            ss_actual_start_date: moment(show.ss_start_date).format(
              "YYYY-MM-DD"
            ),
            ss_start_show_time: show.ss_start_show_time,
          },
        };
        this.$bvModal.show("seatLayoutView");
      },
      goToShow() {
        this.$router.push({
          name: "showtime",
          path: "/showtime",
        });
      },
      scannerSection() {
        this.$router.push({
          name: "qrCode",
          path: "/qrCode",
        });
      },
      onLogout() {
        window.localStorage.removeItem("JWT_TOKEN");
        window.localStorage.removeItem("USERCINEINFO");
        window.localStorage.clear();
        this.$cookie.delete("BRHSID");
        this.$router.push({
          name: "login",
        });
        return window.caches.keys();
      },
      onSubmitBookingCode() {
        if (this.bookingCode) {
          this.$router.push({
            name: "details",
            query: { qrcode: this.bookingCode },
          });
        } else {
          this.$toasted.show("Please Enter Booking Code");
        }
      },
      getAllShowTimes() {
        let loader = this.$loading.show();
        let payload = {
          start_date: moment().format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD"),
          cinema_id: this.cinema_id || null,
          operator: "qrcode",
        };
        BookingService.GetShowTimesList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Dates && data.Dates.length > 0) {
              this.ShowDate = moment(data.Dates[0]).format("DD.MMM.YYYY");
            } else {
              this.ShowDate = moment().format("DD.MMM.YYYY");
            }
            if (data && data.status && data.Records.length > 0) {
              this.scheduleList = data.Records.filter((x) => x.showCount > 0);
              this.scheduleList.sort((a, b) => {
                const getEarliestShow = (schedule) => {
                  const shows = this.getAllShowsSortedByTime(schedule);
                  return shows.length > 0 ? shows[0].show : null;
                };

                const earliestShowA = getEarliestShow(a);
                const earliestShowB = getEarliestShow(b);

                if (!earliestShowA) return 1;
                if (!earliestShowB) return -1;

                const dateTimeA = this.convertToSortableDateTime(earliestShowA);
                const dateTimeB = this.convertToSortableDateTime(earliestShowB);

                return dateTimeA - dateTimeB;
              });
              this.extractAvailableScreens();
              // console.log("this.scheduleList:", this.scheduleList);
              setTimeout(() => {
                this.autoScrollToRunningShows();
              }, 500);
            } else {
              this.$toasted.show(data.message || "No Records Found");
            }
          })
          .catch((err) => {
            console.log("Error: Something Went Wrong", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      getEarliestShowTime(schedule) {
        const shows = this.getAllShowsSortedByTime(schedule);
        if (shows.length === 0) return null;
        return shows[0].show.ss_start_show_time;
      },
      calculateOccupancyPercentage(show) {
        if (!show.screen_total_seats || show.screen_total_seats === 0) return 0;
        const booked = show.booked_seats || 0;
        const percentage = Math.round((booked / show.screen_total_seats) * 100);

        this.$nextTick(() => {
          const progressBar = this.$el.querySelector(".progress-bar");
          if (percentage < 30) {
            progressBar.classList.add("low");
            progressBar.classList.remove("medium", "high");
          } else if (percentage < 70) {
            progressBar.classList.add("medium");
            progressBar.classList.remove("low", "high");
          } else {
            progressBar.classList.add("high");
            progressBar.classList.remove("low", "medium");
          }
        });

        return percentage;
      },
      goToScan() {
        this.$router.push({
          name: "qrCode",
          path: "/qrCode",
        });
      },
    },
  };
</script>
<style>
  /* .view-toggle-section {
  display: flex;
  gap: 10px;
  padding: 15px;
  background-color: white;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: start;
} */

  .top-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    background-color: white;
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    flex-wrap: wrap;
  }

  .view-toggle-section {
    display: flex;
    /* gap: 10px; */
  }

  .filter-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .view-toggle-btn {
    padding: 4px 8px;
    border: 1px solid gray;
    background-color: transparent;
    color: gray;
    border-radius: 6px;
    font-weight: 500;
    font-size: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .view-toggle-btn.active {
    background-color: #4fadb5;
    color: white;
  }

  .view-toggle-btn:hover {
    background-color: #4fadb5;
    color: white;
  }

  .show_card {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .movie-header {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f0f0f0;
  }

  .movie-info {
    flex: 1;
  }

  .movie-title {
    font-size: 16px;
    color: black;
    font-weight: 700;
    margin-bottom: 5px;
  }

  .movie-year {
    font-size: 12px;
    color: #818183;
    font-weight: 400;
  }

  .movie-meta {
    display: flex;
    align-items: center;
    /* gap: 10px; */
    margin-left: 5px;
  }
  .movie-meta span:not(:last-child) {
    margin-right: 10px; /* adjust as needed */
  }
  .rating-badge,
  .runtime-badge {
    color: black;
    background-color: #f6f6f6;
    padding: 4px 8px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 4px;
  }

  .version-badge {
    background-color: #4fadb5;
    color: white;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 10px;
    border: 1px solid #4fadb5;
    border-radius: 6px;
    padding: 2px 8px;
  }

  .divider {
    color: #666;
    font-weight: 500;
  }

  /* Show Details */
  .show-details {
    background-color: #fafafa;
    border-radius: 8px;
    padding: 12px;
  }

  .show-main-info {
    display: grid;
    grid-template-columns: auto auto 1fr auto;
    align-items: center;
    /* gap: 10px; */
    margin-bottom: 10px;
  }

  .show-additional-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .show-format {
    background-color: #e8f5e8;
    color: #2e7d32;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    border: 1px solid #c8e6c9;
  }
  /* show time style */
  .showtime-box {
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 16px;
    background-color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .showtime-row {
    display: grid;
    grid-template-columns: auto auto 1fr auto;
    align-items: center;
    gap: 10px;
  }

  /* .status-dot-container {
  display: flex;
  align-items: center;
  justify-content: center;
} */

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .status-dot:hover {
    transform: scale(1.2);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .status-dot.status-running {
    background-color: #4caf50;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.3);
  }

  .status-dot.status-upcoming {
    background-color: #ffc107;
    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.3);
  }

  .status-dot.status-past {
    background-color: #9e9e9e;
    box-shadow: 0 0 0 2px rgba(158, 158, 158, 0.3);
  }

  .status-dot.status-unknown {
    background-color: #e0e0e0;
  }

  .show-timings {
    color: #555;
    font-weight: 500;
  }

  .show_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f6f6f6;
    padding: 15px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
  }
  h2,
  h3 {
    margin-bottom: 0px;
  }
  .title {
    font-size: 16px;
    color: black;
    font-weight: 700;
  }
  .upper {
    text-transform: uppercase;
  }
  .date {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    color: #818183;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.6px;
  }
  .schedule_main {
    /* background-color: white;
  padding: 15px; */
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 16px;
    background-color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }
  .rating {
    color: black;
    background-color: #f6f6f6;
    padding: 5px;
    font-size: 10px;
    font-weight: bold;
  }

  .movie-thumbnail-container {
    margin-right: 12px;
    flex-shrink: 0;
  }

  .movie-thumbnail {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    object-fit: cover;
    border: 1px solid #e0e0e0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .movie-thumbnail-placeholder {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    color: #999;
    text-align: center;
  }

  .movie-details {
    flex: 1;
  }

  .screen_title {
    color: #032d6e;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
  }
  .screening_section {
    margin: 10px 0px;
  }
  .language {
    background-color: #4fadb5;
    color: white;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
    border: 1px solid #4fadb5;
    border-radius: 2px;
  }

  .schedule_main:not(:first-child) {
    margin-top: 10px;
  }
  .btn-logout {
    background-color: #032d6e;
    color: #fff;
    border-radius: 2px;
    /* position: absolute;
  right: 10px; */
    border: none;
  }
  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 4px;
  }
  .data_table {
    margin-top: 5px;
  }
  .show-timings {
    color: #000000;
    font-size: 12px;
    font-weight: 400;
  }
  .progress-bar-container {
    width: 100px;
    margin: 0 10px;
  }

  .progress-bar {
    height: 24px;
    background-color: #f0f0f0 !important;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .progress-bar::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: calc(var(--progress) * 1%);
    background-color: #4fadb5 !important;
    transition: width 0.3s ease;
    border-radius: 12px 0 0 12px;
  }

  .progress-text {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    color: #333;
    line-height: 24px;
    z-index: 1;
    text-shadow: 0 0 2px white;
  }

  .progress-bar.low::before {
    background-color: #4caf50;
  }
  .progress-bar.medium::before {
    background-color: #ffc107;
  }
  .progress-bar.high::before {
    background-color: #f44336;
  }
  .seat-types-flex-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
  }

  .seat-type-item {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #ddd;
    font-size: 12px;
    transition: all 0.2s ease;
  }

  .seat-type-label {
    font-weight: 600;
    text-transform: capitalize;
    color: #333;
  }

  .seat-type-dash {
    color: #666;
    font-weight: 500;
  }

  .seat-type-value {
    font-weight: 700;
    color: #333;
  }

  .filter-section {
    background-color: white;
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  /* .filter-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
} */

  .filter-label {
    font-weight: 600;
    color: #333;
    font-size: 14px;
    min-width: fit-content;
  }

  .screen-filter-select {
    flex: 1;
    min-width: 200px;
    padding: 8px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 6px;
    background-color: white;
    font-size: 14px;
    color: #333;
    transition: border-color 0.3s ease;
    outline: none;
  }

  .screen-filter-select:focus {
    border-color: #4fadb5;
    box-shadow: 0 0 0 3px rgba(79, 173, 181, 0.1);
  }

  .clear-filter-btn {
    background-color: #f44336;
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    transition: background-color 0.3s ease;
  }

  .clear-filter-btn:hover {
    background-color: #d32f2f;
  }

  .filter-info {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #e3f2fd;
    border-radius: 4px;
    border-left: 4px solid #4fadb5;
  }

  .filter-info-text {
    font-size: 13px;
    color: #333;
  }

  .no-results {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;
    background-color: white;
    border-radius: 8px;
    margin: 20px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .no-results-content {
    text-align: center;
    color: #666;
  }

  .no-results-content h3 {
    color: #333;
    margin-bottom: 10px;
  }

  .no-results-content p {
    margin-bottom: 20px;
    font-size: 14px;
  }

  .btn-clear-filter {
    background-color: #4fadb5;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.3s ease;
  }

  .btn-clear-filter:hover {
    background-color: #3d8b91;
  }
  @media (max-width: 768px) {
    .filter-container {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
    }

    .filter-label {
      align-self: flex-start;
    }

    .screen-filter-select {
      flex: 1;
      min-width: 200px;
      padding: 8px 12px;
      border: 2px solid #e0e0e0;
      border-radius: 6px;
      background-color: white;
      font-size: 14px;
      color: #333;
      transition: border-color 0.3s ease;
      outline: none;
    }

    .screen-filter-select:focus {
      border-color: #4fadb5;
      box-shadow: 0 0 0 3px rgba(79, 173, 181, 0.1);
    }

    .seat-types-flex-container {
      gap: 8px;
    }

    .seat-type-item {
      font-size: 11px;
      padding: 3px 6px;
      gap: 3px;
    }

    .seat-type-label {
      font-size: 10px;
    }
  }

  @media (max-width: 480px) {
    .filter-section {
      padding: 10px;
    }

    .progress-bar-container {
      width: 80px;
      margin: 5px auto;
    }
    .seat-types-flex-container {
      gap: 6px;
    }

    .seat-type-item {
      font-size: 10px;
      padding: 2px 4px;
      gap: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ShowTime.vue